import systemTimeOffsetStore from 'generic/SystemTimeOffset/SystemTimeOffset.store';

/** The yearly auto-archive runs July 1; the "recently archived" notice shows July 1–15. */
export const getAutoArchiveSeasonBounds = () => {
  const now = systemTimeOffsetStore.getCurrentTime();
  // July is month index 6.
  return {
    start: now.clone().month(6).date(1).startOf('day'),
    end: now.clone().month(6).date(15).endOf('day')
  };
};

export const isAutoArchiveSeason = (): boolean => {
  const {start, end} = getAutoArchiveSeasonBounds();
  // Inclusive bounds — default isBetween is exclusive and would drop July 1 at midnight.
  return systemTimeOffsetStore.getCurrentTime().isBetween(start, end, undefined, '[]');
};
